// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"101632e2","396":"2620f1b6","455":"d7d0221e"}[chunkId] + ".chunk.js";
};